'use client'

import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator
} from '@/components/Breadcrumps'
import '@/styles/breadcrumbs.scss'
import Link from 'next/link'
import { useSelectedLayoutSegments } from 'next/navigation'
import { PropsWithChildren } from 'react'
import styles from '../truecodepay-pages.module.css'

const productLabels: Record<string, string> = {
	b2b: 'B2B: платежи от юрлиц и ИП',
	b2c: 'B2C: выплаты физлицам'
}

export default function TrueCodePayLayout({ children }: PropsWithChildren) {
	const segments = useSelectedLayoutSegments().filter((s) => !s.startsWith('('))
	const product = segments.find((s) => s in productLabels)
	const isManual = segments.includes('manual')

	return (
		<>
			<Breadcrumb className={styles.breadcrumps}>
				<BreadcrumbList>
					<BreadcrumbItem className={'breadcrumbs__item'}>
						<BreadcrumbLink asChild>
							<Link href='/'>Главная</Link>
						</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>/</BreadcrumbSeparator>
					<BreadcrumbItem className={'breadcrumbs__item'}>
						<BreadcrumbLink asChild>
							<Link href='/it-solutions/'>ИТ-продукты</Link>
						</BreadcrumbLink>
					</BreadcrumbItem>
					{isManual && product ? (
						<>
							<BreadcrumbSeparator>/</BreadcrumbSeparator>
							<BreadcrumbItem className={'breadcrumbs__item'}>
								<BreadcrumbLink asChild>
									<Link href={`/it-solutions/${product}/`}>{productLabels[product]}</Link>
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator>/</BreadcrumbSeparator>
							<BreadcrumbItem className={'breadcrumbs__item'}>
								<BreadcrumbPage className={'breadcrumbs__current-page'}>Руководство</BreadcrumbPage>
							</BreadcrumbItem>
						</>
					) : (
						<>
							<BreadcrumbSeparator>/</BreadcrumbSeparator>
							<BreadcrumbItem className={'breadcrumbs__item'}>
								<BreadcrumbPage className={'breadcrumbs__current-page'}>{product ? productLabels[product] : undefined}</BreadcrumbPage>
							</BreadcrumbItem>
						</>
					)}
				</BreadcrumbList>
			</Breadcrumb>
			<main className={styles.main}>{children}</main>
		</>
	)
}
